export default "__VITE_ASSET__43a46a71__"